import React, { useState, useEffect } from 'react';
import { SingleInputForm , CalloutBlock , CollapsibleBlock } from 'components';
import styled from 'styled-components';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { applyGiftCardRequest } from 'store/cart/actions';
import { GlobalState, isFetching , LoadingState } from 'store/constants';
import { giftCardErrorSelector, giftCardLoadingStateSelector } from 'store/cart/selectors';

// @todo Setup a cart context and wire it in here
const GiftCardWrap = styled(CalloutBlock)`
  padding: 0;
  cursor: pointer;

  button {
    height: 2.2rem;
    padding: 0rem;
    width: 4rem;
  }
`;

export interface GiftCardProps {
  applyGiftCard: (code: string) => void;
  loadingState: LoadingState;
  err: string;
}

const GiftCard = ({ applyGiftCard, err, loadingState }: GiftCardProps): React.JSX.Element => {
  const [giftCardCode, setGiftCardCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [giftCardCode]);

  useEffect(() => {
    setError(err);
  }, [err]);

  return (
    <GiftCardWrap>
      <CollapsibleBlock title="Gift Card">
        <SingleInputForm
          onSubmit={() => {
            if (giftCardCode) {
              setGiftCardCode('');
              setError('');
              applyGiftCard(giftCardCode);
            } else {
              setError('Please enter a valid gift code');
            }
          }}
          value={giftCardCode}
          onChange={setGiftCardCode}
          error={error}
          submitButtonLabel="Apply"
          isLoading={isFetching(loadingState)}
        />
      </CollapsibleBlock>
    </GiftCardWrap>
  );
};

const mapStateToProps = (state: GlobalState) => ({
  err: giftCardErrorSelector(state),
  loadingState: giftCardLoadingStateSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  applyGiftCard: (code: string) => dispatch(applyGiftCardRequest(code))
});

export { GiftCard as TestableGiftCard };

export default connect(mapStateToProps, mapDispatchToProps)(GiftCard);
